import type { ReactElement } from 'react';
import CancelRoundedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleOutlined';
import WarningRoundedIcon from '@mui/icons-material/WarningAmber';
import WatchLaterRoundedIcon from '@mui/icons-material/WatchLaterOutlined';
import { StepStatus } from '@/models/subsidy/status';

const baseIconConfiguration = { fontSize: 24 };

const SuccessIcon = () => (
  <CheckCircleRoundedIcon
    sx={{
      ...baseIconConfiguration,
      color: ({ palette }) => palette.success.main,
    }}
  />
);

const PendingIcon = () => (
  <WatchLaterRoundedIcon
    sx={{
      ...baseIconConfiguration,
      color: ({ palette }) => palette.neutral[500],
    }}
  />
);

const WarningIcon = () => (
  <WarningRoundedIcon
    sx={{
      ...baseIconConfiguration,
      color: ({ palette }) => palette.warning.main,
    }}
  />
);

const ErrorIcon = () => (
  <CancelRoundedIcon
    sx={{
      ...baseIconConfiguration,
      color: ({ palette }) => palette.error.main,
    }}
  />
);

export const StatusIcon = ({ status }: { status?: StepStatus }) => {
  if (!status) return <PendingIcon />;

  const iconMap: Record<StepStatus, ReactElement> = {
    [StepStatus.Success]: <SuccessIcon />,
    [StepStatus.Pending]: <PendingIcon />,
    [StepStatus.Warning]: <WarningIcon />,
    [StepStatus.Error]: <ErrorIcon />,
  };

  return iconMap[status];
};
